var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardDownarrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7.41,
    viewBox: "0 0 12 7.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    "data-name": "Group 4200",
    transform: "translate(-382 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M7.41,8,12,12.58,16.59,8,18,9.41l-6,6-6-6Z",
    transform: "translate(376 224)",
    fill: "#6d7077"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardDownarrowIcon);
export default __webpack_public_path__ + "static/media/keyboard-downarrow-icon.b4e64064d3ad4bbaaf7949c00092d785.svg";
export { ForwardRef as ReactComponent };